import type React from 'react';

import { Hits } from 'react-instantsearch';

import { cn } from '@change/ds-utils';

import { useLandingPage } from 'src/app/pages/search/shared/hooks';

import { DesktopFilters } from './components/DesktopFilters';
import { HitCard } from './components/HitCard';
import { MobileFilters } from './components/MobileFilters';
import { Pagination } from './components/Pagination';
import { SearchResultList } from './components/SearchResultList';

export const SearchResult: React.FC = () => {
	const {
		data: { showLandingPage },
	} = useLandingPage();

	return (
		<div className={cn({ hidden: showLandingPage })} data-qa="search-results-page-content">
			<MobileFilters />
			<div className="container mt-4 pb-20 md:mt-12">
				<div className="grid grid-cols-12 gap-4">
					<DesktopFilters />
					<div className="col-span-1 hidden md:flex" />
					<div className="col-span-12 md:col-span-8">
						<SearchResultList>
							<Hits
								aria-live="polite"
								hitComponent={HitCard}
								classNames={{
									list: 'grid grid-cols-1 divide-y divide-stroke-weaker',
									root: '',
									item: 'w-full first:pt-0 pt-4 pb-4 md:pt-6 md:pb-6',
								}}
							/>
						</SearchResultList>
						<Pagination />
					</div>
				</div>
			</div>
		</div>
	);
};
